import { updateObject } from "utils/helpers/updateObject";
import {
  actionTypes,
  CreateVideoSeriesFailAction,
  CreateVideoSeriesSuccessAction,
  DeleteVideoSeriesFailAction,
  DeleteVideoSeriesSuccessAction,
  FetchVideoSeriesFailureAction,
  FetchVideoSeriesRequestAction,
  FetchVideoSeriesSuccessAction,
  stateStatusType,
  UpdateVideoSeriesFailAction,
  UpdateVideoSeriesSuccessAction,
  VideoSeriesActions,
} from "./actionType";
import { VideoSeriesState, initialState } from "./state";
import { act } from "react";

//FetchVideoSeriessRequest
const FetchVideoSeriessRequest = (
  state: VideoSeriesState,
  action: FetchVideoSeriesRequestAction
) => {
  return updateObject(state, {
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: true,
      error: null,
      status: null,
    },
  });
};

const FetchVideoSeriessSuccess = (
  state: VideoSeriesState,
  action: FetchVideoSeriesSuccessAction
) => {
  return updateObject(state, {
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_series: action.payload,
    },
  });
};

const FetchVideoSeriessFail = (
  state: VideoSeriesState,
  action: FetchVideoSeriesFailureAction
) => {
  return updateObject(state, {
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
      video_series: null,
    },
  });
};

//create series
const CreateVideoSeriesSuccess = (
  state: VideoSeriesState,
  action: CreateVideoSeriesSuccessAction
) => {
  const newVideoSeries = state.videoSeriesState.video_series ?? [];
  return updateObject(state, {
    genericVideoSeriesState: {
      ...state.genericVideoSeriesState,
      isLoading: false,
      error: null,
    },
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      status: stateStatusType.SUCCESS,
      video_series: [...newVideoSeries, action.payload],
    },
  });
};
const CreateVideoSeriesFail = (
  state: VideoSeriesState,
  action: CreateVideoSeriesFailAction
) => {
  return updateObject(state, {
    genericVideoSeriesState: {
      ...state.genericVideoSeriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      status: stateStatusType.FAILED,
      error: action.payload,
    },
  });
};

//update series
const UpdateVideoSeriesSuccess = (
  state: VideoSeriesState,
  action: UpdateVideoSeriesSuccessAction
) => {
  const newVideoSeries =
    state.videoSeriesState?.video_series.map((items) =>
      items.id === action.payload.id ? action.payload : items
    ) ?? [];
  return updateObject(state, {
    genericVideoSeriesState: {
      ...state.genericVideoSeriesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_series: [...newVideoSeries],
    },
  });
};
const UpdateVideoSeriesFail = (
  state: VideoSeriesState,
  action: UpdateVideoSeriesFailAction
) => {
  return updateObject(state, {
    genericVideoSeriesState: {
      ...state.genericVideoSeriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

//delete series
const DeleteVideoSeriesSuccess = (
  state: VideoSeriesState,
  action: DeleteVideoSeriesSuccessAction
) => {
  const newVideoSeries = state.videoSeriesState?.video_series.filter(
    (items) => items.id !== action.payload
  );
  return updateObject(state, {
    genericVideoSeriesState: {
      ...state.genericVideoSeriesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
    },
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      error: null,
      status: stateStatusType.SUCCESS,
      video_series: [...newVideoSeries],
    },
  });
};
const DeleteVideoSeriesFail = (
  state: VideoSeriesState,
  action: DeleteVideoSeriesFailAction
) => {
  return updateObject(state, {
    genericVideoSeriesState: {
      ...state.genericVideoSeriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
    videoSeriesState: {
      ...state.videoSeriesState,
      isLoading: false,
      error: action.payload,
      status: stateStatusType.FAILED,
    },
  });
};

const VideoSeriesReducer = (
  state = initialState,
  action: VideoSeriesActions
) => {
  switch (action.type) {
    case actionTypes.FETCH_VIDEO_SERIES_REQUEST:
      return FetchVideoSeriessRequest(state, action);
    case actionTypes.FETCH_VIDEO_SERIES_SUCCESS:
      return FetchVideoSeriessSuccess(state, action);
    case actionTypes.FETCH_VIDEO_SERIES_FAIL:
      return FetchVideoSeriessFail(state, action);
    case actionTypes.CREATE_VIDEO_SERIES_SUCCESS:
      return CreateVideoSeriesSuccess(state, action);
    case actionTypes.CREATE_VIDEO_SERIES_FAIL:
      return CreateVideoSeriesFail(state, action);
    case actionTypes.UPDATE_VIDEO_SERIES_SUCCESS:
      return UpdateVideoSeriesSuccess(state, action);
    case actionTypes.UPDATE_VIDEO_SERIES_FAIL:
      return UpdateVideoSeriesFail(state, action);
    case actionTypes.DELETE_VIDEO_SERIES_SUCCESS:
      return DeleteVideoSeriesSuccess(state, action);
    case actionTypes.DELETE_VIDEO_SERIES_FAIL:
      return DeleteVideoSeriesFail(state, action);
    default:
      return state;
  }
};

export default VideoSeriesReducer;
